<div class="container d-flex flex-column">
  <div class="heading-div d-flex justify-content-between">
    <div class="fc-address">
    <span class="fc-content"> FC- &nbsp;{{ familyCode }}</span>
    @if(data?.fcMerge){
      <div class="address">
     <span class="fc-content"> Address- </span> <span class="fc-content" style="word-break: break-word;">{{ data.address}}</span>
      </div>
    }
    </div>
    <div class="img-div" (click)="onCrossClick()">
      <img alt="cross" class="img-cross" src="../../../assets/images/cross_white.svg" />
    </div>
  </div>
  <div class="content-div">
    @for(item of data.fcData;track item){
    <div class="d-flex justify-content-between heading-div">
      <span class="content">
        {{item.name }}
      </span>
      <span class="fc-content">
        {{ item.lid }}
      </span>
    </div>
    }
  </div>
</div>